<template>
    <div class="report" v-show="reportParams === null">
        <SiderLayer />
        <div class="report__wrap">
            <div class="report__content">
                <div class="report__inner">
                    <q-tabs v-model="tab" class="tab-passage no-hover">
                        <q-tab v-for="item in tabList" :name="item.idx" :label="item.title" :ripple="false" />
                    </q-tabs>
                    <q-tab-panels v-model="tab">
                        <q-tab-panel name="1">
                            <div ref="scrollTargetRef" class="scroll__container">
                                <div v-if="!isLoading && noReportDaily" class="noDataBox">
                                    <img src="@/assets/images/symbols/folder.png" style="width: 8vw; margin-left: 50px" /><br /><br />
                                    <span class="noDataTxt">{{ msgNoReport }}</span>
                                </div>
                                <div v-if="!noReportDaily">
                                    <div class="select__wrap">
                                        <CusSelect :li-list="levelList" v-model:current="levelModel" @onReturn="onSelect1" />
                                        <CusSelect :li-list="lessonList" v-model:current="lessonModel" @onReturn="onSelect2" />
                                        <!-- <q-select outlined v-model="levelModel" dense :options="levelList" class="select" popup-content-class="b3" dropdown-icon="expand_less" />
                                    <q-select outlined v-model="lessonModel" dense :options="lessonList" popup-content-class="b3" class="select mg_left_16" dropdown-icon="expand_less" /> -->
                                    </div>
                                    <q-markup-table flat bordered style="height: calc(100% - (6.75vmin + 1.92vmin + 3.2vw))">
                                        <thead>
                                            <tr>
                                                <th class="text-center">구분</th>
                                                <th class="text-center">레벨</th>
                                                <th class="text-center">레슨</th>
                                                <th class="text-center">영역</th>
                                                <th class="text-center">발행일</th>
                                                <th class="text-center">분석리포트</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- <tr v-if="noReportDaily" class="noReport">
                                            <td colspan="6">{{ msgNoReport }}</td>
                                        </tr> -->
                                            <tr v-for="item in rows">
                                                <td class="text-center">{{ item.learningTypeStr }}</td>
                                                <td class="text-center">{{ item.level }}</td>
                                                <td class="text-center">{{ item.lesson }}</td>
                                                <td class="text-center">{{ item.areaStr }}</td>
                                                <td class="text-center">{{ item.publishTs }}</td>
                                                <td class="text-center">
                                                    <q-btn
                                                        outline
                                                        color="primary"
                                                        label="보기"
                                                        style="width: 13.3vmin; border-radius: 1.33vmin; font-size: 2vmin; font-weight: 700"
                                                        :onClick="
                                                            () => {
                                                                onClickItem(item, 'daily');
                                                            }
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </q-markup-table>
                                </div>
                            </div>
                        </q-tab-panel>
                        <q-tab-panel name="2">
                            <!-- <div v-if="noReportSAT" class="scroll__container">
                                <div class="noDataBox">
                                    <img src="@/assets/images/symbols/folder.png" style="width: 8vw; margin-left: 50px" /><br /><br />
                                    <span class="noDataTxt">{{ msgNoReport }}</span>
                                </div>
                            </div> -->
                            <div ref="scrollTargetRef" class="scroll__container">
                                <div v-if="!isLoading && noReportSAT" class="noDataBox">
                                    <img src="@/assets/images/symbols/folder.png" style="width: 8vw; margin-left: 50px" /><br /><br />
                                    <span class="noDataTxt">{{ msgNoReport }}</span>
                                </div>
                                <div v-if="!noReportSAT">
                                    <div class="select__wrap">
                                        <CusSelect :li-list="levelList3" v-model:current="levelModel3" @onReturn="onSelect3" />
                                        <!-- <q-select outlined v-model="levelModel" dense :options="levelList" class="select" popup-content-class="b3" dropdown-icon="expand_less" /> -->
                                    </div>
                                    <q-markup-table flat bordered style="height: calc(100% - (6.75vmin + 1.92vmin + 3.2vw))">
                                        <thead>
                                            <tr>
                                                <th class="text-center">레벨</th>
                                                <th class="text-center">회차</th>
                                                <th class="text-center">발행일</th>
                                                <th class="text-center">분석리포트</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- <tr v-if="noReportSAT" class="noReport">
                                            <td colspan="4">{{ msgNoReport }}</td>
                                        </tr> -->
                                            <tr v-for="item in rows2">
                                                <td class="text-center">{{ item.level }}</td>
                                                <td class="text-center">{{ item.title }}</td>
                                                <td class="text-center">{{ item.publishTs }}</td>
                                                <td class="text-center">
                                                    <q-btn
                                                        outline
                                                        color="primary"
                                                        label="보기"
                                                        style="width: 13.3vmin; border-radius: 1.33vmin; font-size: 2vmin; font-weight: 700"
                                                        :onClick="
                                                            () => {
                                                                onClickItem(item, 'sat');
                                                            }
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </q-markup-table>
                                </div>
                            </div>
                        </q-tab-panel>
                        <q-tab-panel name="3">
                            <!-- <div v-if="noReportEval" class="scroll__container">
                                <div class="noDataBox">
                                    <img src="@/assets/images/symbols/folder.png" style="width: 8vw; margin-left: 50px" /><br /><br />
                                    <span class="noDataTxt">{{ msgNoReport }}</span>
                                </div>
                            </div> -->
                            <div ref="scrollTargetRef" class="scroll__container">
                                <div v-if="!isLoading && noReportEval" class="noDataBox">
                                    <img src="@/assets/images/symbols/folder.png" style="width: 8vw; margin-left: 50px" /><br /><br />
                                    <span class="noDataTxt">{{ msgNoReport }}</span>
                                </div>
                                <div v-if="!noReportEval">
                                    <q-markup-table flat bordered class="mg_top_82" style="height: calc(100% - (6.83vmin))">
                                        <thead>
                                            <tr>
                                                <th class="text-center">회차</th>
                                                <th class="text-center">발행일</th>
                                                <th class="text-center">분석리포트</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- <tr v-if="noReportEval" class="noReport">
                                            <td colspan="3">{{ msgNoReport }}</td>
                                        </tr> -->
                                            <tr v-for="item in rows3">
                                                <td class="text-center">{{ item.title }}</td>
                                                <td class="text-center">{{ item.endDate }}</td>
                                                <td class="text-center">
                                                    <q-btn
                                                        outline
                                                        color="primary"
                                                        class="btn__report"
                                                        label="보기"
                                                        style="width: 13.3vmin; border-radius: 1.33vmin; font-size: 2vmin; font-weight: 700"
                                                        :onClick="
                                                            () => {
                                                                onClickItem(item, 'diagnostic');
                                                            }
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </q-markup-table>
                                </div>
                            </div>
                        </q-tab-panel>
                        <!-- //2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트 -->
                        <q-tab-panel name="4">
                            <div ref="scrollTargetRef" class="scroll__container">
                                <div v-if="!isLoading && noReportMonthly" class="noDataBox">
                                    <img src="@/assets/images/symbols/folder.png" style="width: 8vw; margin-left: 50px" /><br /><br />
                                    <span class="noDataTxt">{{ msgNoReport }}</span>
                                </div>
                                <div v-if="!noReportMonthly">
                                    <q-markup-table flat bordered class="mg_top_82" style="height: calc(100% - (6.83vmin))">
                                        <thead>
                                            <tr>
                                                <th class="text-center">구분</th>
                                                <th class="text-center">발행일</th>
                                                <th class="text-center">분석리포트</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in rows4">
                                                <td class="text-center">{{ item.title }}</td>
                                                <td class="text-center">{{ item.create_date }}</td>
                                                <td class="text-center">
                                                    <q-btn
                                                        outline
                                                        color="primary"
                                                        class="btn__report"
                                                        label="보기"
                                                        style="width: 13.3vmin; border-radius: 1.33vmin; font-size: 2vmin; font-weight: 700"
                                                        :onClick="
                                                            () => {
                                                                onClickItem(item, 'monthly');
                                                            }
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </q-markup-table>
                                </div>
                            </div>
                        </q-tab-panel>
                        <q-tab-panel name="5">
                            <div ref="scrollTargetRef" class="scroll__container">
                                <div>
                                    <q-markup-table flat bordered class="mg_top_82" style="height: calc(100% - (6.83vmin))">
                                        <thead>
                                            <tr>
                                                <th class="text-center">구분</th>
                                                <th class="text-center">발행일</th>
                                                <th class="text-center">분석리포트</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in rows5" :key="item.kreadReportRangeOrd">
                                                <td class="text-center">{{ item.kreadReportRangeNm }} KReaD 독해력 분석리포트</td>
                                                <td class="text-center">{{ item.createTs && item.isPublishReport ? moment(item.createTs).format('YYYY.MM.DD') : ' - ' }}</td>
                                                <td class="text-center">
                                                    <q-btn
                                                        outline
                                                        v-bind:disabled="!item.isPublishReport"
                                                        color="primary"
                                                        class="btn__report"
                                                        label="보기"
                                                        style="width: 13.3vmin; border-radius: 1.33vmin; font-size: 2vmin; font-weight: 700"
                                                        :onClick="
                                                            () => {
                                                                onClickItem(item, 'kread');
                                                            }
                                                        "
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </q-markup-table>
                                </div>
                            </div>
                        </q-tab-panel>
                    </q-tab-panels>
                </div>
            </div>
        </div>
    </div>
    <template v-if="reportParams" style="height: 100vh">
        <Report :reportParams="reportParams" @close="onCloseReport" :type="tab" />
    </template>
    <LoadingCard :is-show="isLoading" />
</template>

<script setup>
// 리포트 추가
import { getReportList, getReportListSat, getReportListDiagnostic, getReportMonthlyAnalysis, getReportListKread } from '@/api/modules/study';
import SiderLayer from '@/components/layouts/sider/siderLayer.vue';
import CusSelect from '@/components/widget/CusSelect.vue';
import { historyBack } from '@/helpers/utils';
import { ref, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import Report from './report.vue';
import { GlobalStore } from '@/store';
import { useQuasar } from 'quasar';
import LoadingCard from '@/components/quasar/loadingCard.vue';
import Comm from '@/components/common.js';
import { monitoringLog } from '@/api/modules/monitoring';
import moment from 'moment';

const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();
const isLoading = ref(true);

const noReportDaily = ref(true);
const noReportSAT = ref(true);
const noReportEval = ref(true);
const noReportMonthly = ref(true); //2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트
const msgNoReport = ref('아직은 분석리포트가 없어요.');

const tab = ref('1');
const tabList = [
    { title: '학습 분석리포트', idx: '1' },
    { title: '수능모의평가 분석리포트', idx: '2' },
    { title: '진단평가 분석리포트', idx: '3' },
    //2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트
    { title: '월간 분석리포트', idx: '4' },
    { title: '독해력 분석리포트', idx: '5' },
    //     { label: '학습 분석리포트', value: '1' },
];

//////// -------학습리포트_셀렉터--------////////
const levelList = [
    { label: '전체 레벨', value: '전체 레벨' },
    { label: '1레벨', value: '1' },
    { label: '2레벨', value: '2' },
    { label: '3레벨', value: '3' },
];
const levelModel = ref({ label: '전체 레벨', value: '전체 레벨' });
const onSelect1 = (index) => {
    levelModel.value = levelList[index];
};
const lessonList = [...Array(97)].map((i, index) => {
    if (index === 0) return { label: '전체 레슨', value: '전체 레슨' };
    return { label: index + '레슨', value: index };
});
const lessonModel = ref({ label: '전체 레슨', value: '전체 레슨' });
const onSelect2 = (index) => {
    lessonModel.value = lessonList[index];
};

//////// -------수능리포트_셀렉터--------////////
const levelList3 = [
    { label: '전체 레벨', value: '전체 레벨' },
    { label: '1레벨', value: '1' },
    { label: '2레벨', value: '2' },
    { label: '3레벨', value: '3' },
];
const levelModel3 = ref({ label: '전체 레벨', value: '전체 레벨' });
const onSelect3 = (index) => {
    levelModel3.value = levelList[index];
};

const rows = ref([]);
const rows2 = ref([]);
const rows3 = ref([]);
const rows5 = ref([]);
const rows4 = ref([]);
const scrollTargetRef = ref(null);
const reportParams = ref(null);
const kreadReportParams = ref(null);
//////// -------데이터_받아오기--------////////
const hitDaily = () => {
    const tmpLevel = levelModel.value.value === '전체 레벨' ? null : levelModel.value.value;
    const tmpLesson = lessonModel.value.value === '전체 레슨' ? null : lessonModel.value.value;
    getReportList({ level: tmpLevel, lesson: tmpLesson }, (rs) => {
        rows.value = rs;
        noReportDaily.value = levelModel.value.value === '전체 레벨' && lessonModel.value.value === '전체 레슨' && rows.value.length < 1;
        isLoading.value = false;
    });
};
const hitSAT = () => {
    const tmpLevel = levelModel3.value.value === '전체 레벨' ? null : levelModel3.value.value;
    getReportListSat({ level: tmpLevel }, (rs) => {
        rows2.value = rs;
        noReportSAT.value = levelModel3.value.value === '전체 레벨' && rows2.value.length < 1;
        isLoading.value = false;
    });
};
const hitEval = () => {
    getReportListDiagnostic({}, (rs) => {
        rows3.value = rs.filter((e) => e.endDate); // 완료 안 된 진단평가 제거 후 대입.
        noReportEval.value = rows3.value.length < 1;
        isLoading.value = false;
    });
};
//2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트
const hitMonthly = () => {
    getReportMonthlyAnalysis({}, (rs) => {
        rows4.value = rs;
        noReportMonthly.value = rows4.value.length < 1;
        isLoading.value = false;
    });
};

const hitKread = () => {
    getReportListKread({}, (rs) => {
        rows5.value = rs;
        console.log('rows5', rows5.value);
        isLoading.value = false;
    });
};
const getData = () => {
    isLoading.value = true;
    if (tab.value === '1') hitDaily();
    if (tab.value === '2') hitSAT();
    if (tab.value === '3') hitEval();
    //2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트
    if (tab.value === '4') hitMonthly();
    if (tab.value === '5') hitKread();
};

const onClickItem = (item, type) => {
    if (type === 'daily') {
        reportParams.value = {
            ...item?.reportRedirectKey,
            learningTypeStr: item.learningTypeStr,
        };
    } else if (type === 'sat') {
        reportParams.value = {
            learningHistorySeq: item?.learningHistorySeq,
            level: item?.title,
        };
    } else if (type === 'diagnostic') {
        reportParams.value = {
            diagnosticSeq: item?.diagnosticSeq,
        };
    } else if (type === 'monthly') {
        //2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트
        console.log('items', item);
        reportParams.value = {
            studentSeq: item.student_seq,
            groupNo: item.group_no,
            createDate: item.create_date,
        };
    } else if (type === 'kread') {
        reportParams.value = {
            ...item,
        };
    }
};

watch([tab, levelModel, lessonModel, levelModel3], (newValue) => {
    getData();
});

onMounted(() => {
    gStore.setIsMemberEval(true);
    Comm.setDeviceType();
    getData();

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('analysisreport monitoringLog API response ===', res);
    });
});

const onCloseReport = () => {
    reportParams.value = null;
};
</script>

<style scoped lang="scss">
.noDataBox {
    width: 100%;
    text-align: center;
    padding-top: 36.9vh;
    overflow: auto;
}
.noDataTxt {
    color: #8e8e8e;
}

.report {
    display: flex;

    &__wrap {
        position: relative;
        width: 90%;
    }

    &__content {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        @include transform(translateY(-50%));
    }

    &__inner {
        padding: 0 2.3vw;
    }
}

.tab-passage {
    height: 8.17vmin;

    .q-tab {
        width: 50%;
    }

    .q-tabs__content {
        .q-tab--active:nth-child(1) + div {
            border-left: 0px;
            border-right: 0px;
        }
        .q-tab--inactive:has(~ .q-tab--active) {
            border-right: 0px;
        }
        .q-tab--active:nth-child(2) + div {
            border-left: 0px;
        }
    }

    ::v-deep .q-tab__label {
        color: $text_primary;
        font-size: 1.3vw;
        line-height: 2.1vw;
        font-weight: 700;
    }

    .q-tab--active {
        border: 2px solid $color_gray_900;
        // border-top: 2px solid #222222;
        // border-left: 2px solid #222222;
        // border-right: 2px solid #222222;
        border-bottom: 0;
        @include border-radius(0.8vw 0.8vw 0 0);
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
    }

    .q-tab--inactive {
        border: 2px solid $color_gray_400;
        // border-top: 2px solid #e0e0e0;
        // border-left: 2px solid #e0e0e0;
        // border-right: 2px solid #e0e0e0;
        border-bottom: 2px solid $color_gray_900;
        @include border-radius(0.8vw 0.8vw 0 0);
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
    }

    ::v-deep .q-tab__indicator {
        display: none !important;
    }

    ::v-deep .q-tab--inactive {
        // border-bottom: 2px solid #222222;
        z-index: 10;

        .q-tab__label {
            color: #bdbdbd;
        }
    }
}

.scroll__container {
    height: calc(100vh - 17.17vmin);
    overflow: auto;
    font-size: 1.2vw;
    line-height: 1.6vw;

    .select__wrap {
        display: flex;
        margin-top: 6.75vmin;
        margin-bottom: 1.92vmin;

        .select {
            // width: 18.33vmin;
            font-size: 1.2vw;
            line-height: 1.6vw;
            color: $color_gray_600;
        }
    }
}

.q-markup-table {
    // border-radius: 20px;
    @include border-radius(0.8vw);
}

::v-deep {
    .q-field__control {
        padding: 0 2.83vmin;
    }

    .q-field__native {
        min-height: 64px !important;
        color: $color_gray_600;
    }

    .q-field__append {
        min-height: 64px !important;

        .q-icon {
            color: $color_gray_600;
            font-size: 2.5vw;
        }
    }

    .q-table {
        font-size: 2vmin;

        th {
            background-color: $color_gray_100;
            font-size: 2vmin;
            padding: 2.3vmin 0 2vmin;
            height: 8.75vmin;
        }

        td {
            font-size: 1.2vw;
            line-height: 1.6vw;
            font-weight: 400;
            height: 7.75vmin;
        }
    }

    .q-tab-panel {
        padding: 0 !important;
    }
}

.mg_top_82 {
    margin-top: 6.83vmin;
}

.btn__report {
    width: 13.3vmin;
    border-radius: 1.33vmin;
    font-size: 1.2vw;
    line-height: 1.6vw;
    font-weight: 700;
}

.btn__report:disabled {
    background-color: #bdbdbd !important;
}

::v-deep {
    input {
        //padding: 1.6vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    .q {
        &-field {
            overflow: hidden;
            margin-top: 0px;

            &__control {
                align-items: center;
                height: 100%;
                border-radius: 1vmin;
                width: 11vw;
                //height: 3.2vw;
                min-height: inherit;
                padding: 0.92vmin 1.83vmin;
                text-align: center;
            }

            &__native {
                min-height: inherit !important;
                padding: 0;
                font-size: 1.2vw;
                line-height: 1.6vw;
                color: $color_gray_600;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                // padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }
    }

    .q-field__control-container {
        align-items: center;
    }

    .q-field__marginal {
        width: 2.1vw;
        height: 2.1vw;
        min-height: inherit !important;
        padding-left: 0;
    }

    .q-select__dropdown-icon {
        width: 2.1vw;
        height: 2.1vw;
        text-indent: 9999rem;
        background: url('@/assets/images/icon/ico_down.svg') no-repeat center right/ contain;
    }

    .q-table thead,
    .q-table tr,
    .q-table th,
    .q-table td {
        border-color: $color_gray_400;
        border-bottom: 1px solid $color_gray_400;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.noReport {
    margin: 0 auto;
    text-align: center;
    // padding: 160px;
    // background-color: #00a2e0;
}
</style>
